<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ADfVzR/tc-custom/9780823234219.jpg?1736422839449" alt="This image is the cover for the book Angels of Mercy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Angels of Mercy
      </h1>
      <p class="bookDescription body article font2">
        <b>This history of the nation’s first orphanage for African American children, founded in New York City nearly two centuries ago.</b><br/><br/>This book uncovers the history of the Colored Orphan Asylum, founded in 1836. Through three wars, two major financial panics, a devastating fire during the 1863 Draft Riots, several epidemics, waves of racial prejudice, and severely strained budgets, it cared for orphaned, neglected, and delinquent children, eventually receiving financial support from such renowned New York families as the Jays, Murrays, Roosevelts, Macys, and Astors.<br/><br/>While the white female managers and their male advisers were dedicated to uplifting these children, the evangelical, mainly Quaker founding managers also exhibited the extreme paternalistic views endemic at the time, accepting advice or support from the African American community only grudgingly. It was frank criticism in 1913 from W.E.B. Du Bois that highlighted the conflict between the orphanage and the community it served, and it wasn’t until 1939 that it hired the first black trustee.<br/><br/>More than 15,000 children were raised in the orphanage, and throughout its history letters and visits have revealed that hundreds if not thousands of “old boys and girls” looked back with admiration and respect at the home that nurtured them throughout their formative years. Weaving together African American history with a unique history of New York City, this is not only a painstaking study of a previously unsung institution but a unique window onto complex racial dynamics during a period when many failed to recognize equality among all citizens as a worthy purpose. In its current incarnation as Harlem-Dowling West Side Center for Children and Family Services, it continues to aid children (albeit not as an orphanage)—and maintains the principles of the women who organized it so long ago.<br/><br/>“Scholars and general readers interested in New York history, race relations, social services, [or] philanthropy . . . will benefit from this work.”<i>?Social Sciences Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William Seraile
      </h2>
      
      <p class="authorDescription body article">William Seraile is a professor emeritus at Lehman College, City University of New York,where he taught African American history for 36 years. His most recent books are New York’s Black Regiments During the Civil War and Bruce Grit: The Black Nationalist Writings of John Edward Bruce.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Fordham University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?011621c3